import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/site/SEO";

export default function NotFound() {
  return (
    <div className="bg-brand-black text-white min-h-[70vh] flex items-center">
      <SEO title="Page Not Found" description="This page has not been captured yet." noindex />
      <div className="mx-auto max-w-3xl px-5 md:px-10 py-24 text-center">
        <div className="eyebrow text-brand-blue">404</div>
        <h1 className="mt-4 text-[44px] md:text-6xl font-bold tracking-tight">This page has not been captured yet.</h1>
        <p className="mt-6 text-white/60 text-[16px]">The link is off, or the page has moved. The rest of the standard is still here.</p>
        <Link to="/" className="mt-10 inline-flex items-center gap-2 bg-white text-brand-black px-6 py-3.5 text-[13px] font-bold">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
      </div>
    </div>
  );
}
